<template>
  <section class="container">
    <div class="row justify-content-center justify-content-md-between mb-3 mr-0 ml-2 ml-sm-0">
      <div class="col-auto px-0">
        <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
          Regresar
        </mdb-btn>
      </div>
    </div>
    <div class="encabezado-detalles">
      <header class="h4-responsive text-center pt-3">Reporte</header>
      <div class="row mx-0 mt-2">
        <div class="col-12 col-md-4">
          <span class="small-block font-titulo">Nombre del reporte</span>
          <p>
            Clientes Vendedor Presentaciones
          </p>
        </div>
        <div class="col-12">
          <span class="small-block font-titulo">Descripción</span>
          <p class="mb-1">
            Muestra la cantidad total de productos pedidos por los clientes en el rango de fecha seleccionado.
            <span v-if="!vendedoresFiltrados.length">de todos los vendedores.</span>
            <span v-else-if="vendedoresFiltrados.length >= 2" class="d-inline">
              de los vendedores:
              <span v-for="(vende, index) in vendedoresFiltrados" :key="index" class="text-capitalize">
                {{ vende.nom_per + ' ' + vende.ape_per + (index === (vendedoresFiltrados.length - 1) ? '. ' : ', ') }}
              </span>
            </span>
            <span v-else>
              del vendedor {{ vendedoresFiltrados[0].nom_per + ' ' + vendedoresFiltrados[0].ape_per }}.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 col-xl-3">
        <mdb-input v-model="fechaResumen" type="month" label="Mes" class="my-2" outline />
      </div>
      <div class="col-12 col-sm col-md-4 col-xl-3">
        <mdb-input class="my-2" v-model="fechaDel" type="date" label="Desde" outline />
      </div>
      <div class="col-12 col-sm col-md-4 col-xl-3">
        <mdb-input class="my-2" v-model="fechaHasta" type="date" label="Hasta" outline />
      </div>
      <div class="col-12 col-md-6 col-xl-3 px-0">
        <FiltrosTipo1 :ven="vendedoresFiltro" :responsive="responsive" :restablecer-filtrado="restablecer"
          :mostrar-btn-restablecer="false" @vendedorAFiltrar="vendedoresAFiltrar = $event; actualizar()" />
      </div>
      <div class="col-12 col-md-3 text-center">
        <mdb-btn color="primario" icon="cube" class="px-1 my-2 text-capitalize rounded-pill py-2 w-100" @click="mostrarPresentaciones = true">
          Presentaciones
        </mdb-btn>
      </div>
      <div v-if="fechaHasta.length && fechaDel.length || vendedoresAFiltrar.length || presentacion.length" class="col-12 col-md-3 text-center">
        <mdb-btn flat dark-waves icon="broom" class="my-2 px-1" @click="restablecerFiltros()">
          Restablecer filtros
        </mdb-btn>
      </div>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <div v-else>
      <div v-if="Object.keys(clientes).length" class="container">
        <ul class="table reporte-clientes">
          <li class="encabezado sticky">
            <div class="thead claro">
              <div class="col-3">
                Empresa
                <small class="small-block">
                  Sucursal
                </small>
              </div>
              <div class="col-2">
                Contacto
              </div>
              <div class="col-4">
                Producto
                <small class="small-block">
                  Presentación - Código
                </small>
              </div>
              <div class="col-3 text-right">
                Cantidad
              </div>
            </div>
          </li>
          <li v-for="(c, index) in clientes" :key="index">
            <div class="contenido">
              <div class="col-12 col-sm-3" data-columna="Empresa / Sucursal">
                <p>
                  {{ c.nom_emp }}
                  <small class="small-block">
                    {{ c.nom_suc }}
                  </small>
                </p>
              </div>
              <div class="col-12 col-sm-2" data-columna="Contacto">
                {{ c.contacto }}
              </div>
              <div class="col-12 col-sm-4" data-columna="Producto / Presentación - Código">
                <p>
                  {{ c.nom_pro }}
                  <small class="small-block">
                    {{ c.des_pre }} - {{ c.cod_pre }}
                  </small>
                </p>
              </div>
              <div class="col-12 col-sm-3 text-right" data-columna="Cantidad">
                {{ c.cantidad }}
              </div>
            </div>
          </li>
          <li>
            <div class="contenido claro font-weight-bold">
              <div class="col-12 col-sm-9" data-columna="Totales">
                Totales: {{ totalesReporte.clientes }} clientes ·
                {{ totalesReporte.registros }} registros
              </div>
              <div class="col-12 col-sm-3 text-right" data-columna="Cantidad total">
                {{ totalesReporte.cantidad }}
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-else class="mensaje-no-items py-3">
        <font-awesome-icon
          :icon="!vendedoresAFiltrar.length || !presentacion.length ? 'search' : 'user'"
          size="5x"
          class="icono"
        />
        <p v-if="!vendedoresAFiltrar.length || !presentacion.length" class="texto">
          Selecciona uno o varios vendedores y presentaciones
          <span class="d-block">para generar el reporte</span>
        </p>
        <p v-else class="texto">No hay clientes para mostrar</p>
      </div>
    </div>
    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
    <mdb-modal centered elegant scrollable size="lg" :show="mostrarPresentaciones" @close="mostrarPresentaciones = false">
      <mdb-modal-header>
        <mdb-modal-title>Presentaciones</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="p-0">
        <div class="col col-sm-6">
          <mdb-input class="mb-0" label="Buscar" icon="search" v-model="buscar" @input="obtenerPresentaciones($event)" />
          <small class="small-block">Buscar por producto, presentacion o categorias</small>
        </div>
        <div v-if="cargandoPresentaciones" class="mensaje-no-items py-3">
          <LoaderKel />
          <p class="texto mt-2">
            Cargando
          </p>
        </div>
        <div v-else-if="Object.keys(categorias).length">
          <div class="container">
            <div class="col-12">
              <div v-for="(cat, Catindex) in categorias" :key="Catindex">
                <header class="h4-responsive text-capitalize">
                  {{ Catindex }}
                </header>
                <div class="d-flex flex-wrap gap-chips">
                  <label v-for="(pre, i) in cat" :key="i" class="chip-checkbox"
                    :class="{ 'chip-active primario': presentacion.includes(pre.id_pre) }">
                    <input type="checkbox" :value="pre.id_pre" :checked="presentacion.includes(pre.id_pre)"
                      @change="seleccionarPre($event, pre.id_pre)" class="chip-input" />
                    <span class="chip-label">
                      <span class="chip-titulo">{{ pre.nom_pro }} - {{ pre.des_pre }}</span>
                      <small class="chip-meta">
                        <span class="chip-codigo">Cód. {{ pre.cod_pre }}</span>
                        · {{ pre.uni_paq_pre }} {{ pre.paq_pre }} · {{ Number(pre.pes_pre).toFixed(2) }} kg
                      </small>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="mensaje-no-items pb-3">
          <font-awesome-icon icon="boxes" size="5x" class="icono" />
          <p class="texto">Sin presentaciones disponibles</p>
        </div>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="primario" class="rounded-lg" @click="mostrarPresentaciones = false; actualizar()">
          Aceptar
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </section>
</template>

<script>
import { mdbInput, mdbBtn, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue'
import FiltrosTipo1 from '@/components/FiltrosTipo1.vue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import { apiPost } from '@/funciones/api.js'
import LoaderKel from '@/components/LoaderKel.vue'

export default {
  name: 'ClientesVendedorPresentaciones',
  components: {
    mdbInput,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    FiltrosTipo1,
    AlertaMensaje,
    LoaderKel
  },
  data () {
    return {
      responsive: { vendedor: 'col-12' },
      fechaResumen: new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2),
      fechaDel: '',
      fechaHasta: '',
      vendedoresFiltro: [],
      vendedoresAFiltrar: [],
      vendedoresFiltrados: [],
      presentaciones: [],
      presentacion: [],
      clientes: [],
      cargando: false,
      restablecer: false,
      alertaMensaje: { contenido: '' },
      mostrarPresentaciones: false,
      buscar: '',
      timeout: null,
      cargandoPresentaciones: false
    }
  },
  computed: {
    categorias () {
      if (!this.presentaciones) return []
      const cate = {}
      this.presentaciones.forEach((pre) => {
        if (!cate[pre.nom_cat]) {
          cate[pre.nom_cat] = {}
        }
        cate[pre.nom_cat][pre.id_pre] = pre
      })
      return cate
    },
    totalesReporte () {
      const clientesUnicos = new Set()
      let cantidad = 0
      this.clientes.forEach((c) => {
        clientesUnicos.add(c.id_suc)
        cantidad += Number(c.cantidad) || 0
      })
      return {
        registros: this.clientes.length,
        clientes: clientesUnicos.size,
        cantidad
      }
    }
  },
  mounted () {
    this.actualizar()
    this.obtenerVendedoresFiltros()
    this.obtenerPresentaciones()
  },
  watch: {
    fechaResumen () {
      this.fechaDel = ''
      this.fechaHasta = ''
      this.actualizar()
    },
    fechaHasta () {
      if (!this.fechaHasta) return
      this.actualizar()
    },
    fechaDel () {
      if (!this.fechaHasta) return
      this.actualizar()
    },
    vendedoresAFiltrar () {
      this.vendedoresFiltrados = []
      this.vendedoresSeleccionados()
    }
  },
  methods: {
    seleccionarPre (event, id) {
      if (event.target.checked) {
        this.presentacion.push(id)
      } else {
        this.presentacion.splice(this.presentacion.indexOf(id), 1)
      }
    },
    vendedoresSeleccionados () {
      this.vendedoresAFiltrar.forEach(vende => {
        this.vendedoresFiltro.forEach(vendefiltrado => {
          return vendefiltrado.id_per === vende ? this.vendedoresFiltrados.push(vendefiltrado) : null
        })
      })
    },
    restablecerFiltros () {
      this.restablecer = true
      this.fechaDel = ''
      this.fechaHasta = ''
      this.vendedoresAFiltrar = []
      this.vendedoresFiltrados = []
      this.presentacion = []
      this.clientes = []
      this.fechaResumen = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)
      this.actualizar()
      setTimeout(() => {
        this.restablecer = false
      }, 500)
    },
    obtenerVendedoresFiltros () {
      apiPost({ s: 'vendedores' }, '')
        .then((res) => {
          this.vendedoresFiltro = res.data.ven
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los clientes',
            tipo: 'error'
          }
        })
    },
    obtenerPresentaciones (buscar = '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.cargandoPresentaciones = true
        const data = 'nom_pre=' + buscar
        apiPost({ s: 'presentacionesLimitadas' }, data)
          .then((res) => {
            this.presentaciones = res.data.pre
            this.cargandoPresentaciones = false
          }).catch(() => {
            this.alertaMensaje = {
              contenido: 'Ocurrió un error obteniendo las presentaciones',
              tipo: 'error'
            }
          })
      }, 500)
    },
    actualizar () {
      if (!this.vendedoresAFiltrar.length || !this.presentacion.length) return
      this.cargando = true
      let data = this.fechaResumen && this.fechaResumen.length && `y=${this.fechaResumen.split('-')[0]}&m=${this.fechaResumen.split('-')[1]}`
      data += this.fechaHasta ? '&del=' + this.fechaDel + '&al=' + this.fechaHasta : ''
      this.vendedoresAFiltrar && this.vendedoresAFiltrar.length && (data += `&ven=${this.vendedoresAFiltrar.join(',')}`)
      data += this.presentacion.length ? `&pre=${this.presentacion.join(',')}` : ''
      apiPost({ s: 'cliPedVen' }, data)
        .then((res) => {
          this.clientes = res.data.cli
          this.cargando = false
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los clientes',
            tipo: 'error'
          }
          this.cargando = false
        })
    }
  }

}
</script>

<style lang='scss' scoped>
.table.reporte-clientes {
  @include ul-table-responsive-at ("576px");
}
.chip-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  margin: 4px;
  /* Espaciado entre chips */
  border-radius: 12px;
  border: 1px solid #d1d5db;
  background-color: #f3f4f6;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease-in-out;
}

.chip-label {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  text-align: left;
}

.chip-titulo {
  white-space: normal;
}

.chip-meta {
  font-size: 11px;
  font-weight: 400;
  opacity: .75;
}

.chip-codigo {
  font-weight: 600;
}

/* Contenedor flexible para ajustar los chips */
.gap-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  /* Espaciado moderno entre chips */
}

/* Ocultar el checkbox cuadrado nativo */
.chip-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  pointer-events: none;
}

/* Estado hover cuando no está activo */
.chip-checkbox:hover {
  background-color: #e5e7eb;
}

/* Estado activo / seleccionado */
.chip-checkbox.chip-active {
  background-color: rgba($primario, $alpha: 1.0);
  color: #ffffff;
}

/* Indicador de accesibilidad (Focus) */
.chip-checkbox:focus-within {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

</style>
